var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navigation-preview", class: _vm.rootClasses },
    [
      _c("transition", { attrs: { name: "trs-simple-fade" } }, [
        _vm.isVisible
          ? _c("div", {
              key: "backdrop",
              staticClass: "navigation-preview--background",
              on: { click: _vm.onBackgroundClicked }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isVisible,
              expression: "isVisible"
            }
          ],
          key: "overlay",
          ref: "overlay",
          staticClass: "navigation-preview--overlay",
          style: _vm.position,
          on: { mouseover: _vm.onHover, mouseleave: _vm.onLeave }
        },
        [
          _c(
            "div",
            { ref: "preview", staticClass: "navigation-preview--wrapper" },
            [
              _vm.previewContent && _vm.previewContent.component
                ? _c(
                    "div",
                    { staticClass: "navigation-preview--content" },
                    [
                      _c(
                        _vm.previewContent.component,
                        _vm._b(
                          { tag: "component" },
                          "component",
                          _vm.previewContent.props,
                          false
                        )
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.previewLinks
                ? _c(
                    "div",
                    { staticClass: "navigation-preview--links" },
                    _vm._l(_vm.previewLinks, function(link, idx) {
                      return link.label
                        ? _c(
                            "navigation-entry",
                            _vm._b(
                              {
                                key: idx,
                                staticClass: "navigation-preview--link",
                                attrs: { facets: ["nav-preview"] }
                              },
                              "navigation-entry",
                              link,
                              false
                            )
                          )
                        : _vm._e()
                    }),
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-770a831b", { render: render, staticRenderFns: staticRenderFns })
  }
}